import { render } from "./SelecaoEdicao.vue?vue&type=template&id=447663d4&scoped=true&ts=true"
import script from "./SelecaoEdicao.vue?vue&type=script&lang=ts"
export * from "./SelecaoEdicao.vue?vue&type=script&lang=ts"

import "./SelecaoEdicao.vue?vue&type=style&index=0&id=447663d4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447663d4"]])

export default __exports__